// ────────────────────────────────────────────────────────────────────────────
//  BackgroundOrbs.tsx — Animierte Glas-Orbs im Hintergrund
//  Drei riesige Blur-Bälle die langsam durch den Viewport schweben.
//  Performance: pure CSS-Animation, kein JS, läuft auf der GPU.
// ────────────────────────────────────────────────────────────────────────────

export function BackgroundOrbs() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
      {/* Hauptfarbverlauf */}
      <div className="absolute inset-0 bg-[radial-gradient(at_top_left,rgba(138,68,238,0.20),transparent_55%),radial-gradient(at_bottom_right,rgba(58,98,255,0.18),transparent_55%),radial-gradient(at_bottom_left,rgba(255,91,92,0.10),transparent_50%)]" />

      {/* Lila Orb oben links */}
      <div
        className="absolute -top-32 -left-32 w-[600px] h-[600px] rounded-full
                   bg-gradient-radial from-accent/40 to-transparent
                   blur-3xl animate-float-orb-1"
        style={{ background: 'radial-gradient(circle, rgba(138,68,238,0.45), transparent 60%)' }}
      />

      {/* Blauer Orb rechts mitte */}
      <div
        className="absolute top-1/3 -right-40 w-[700px] h-[700px] rounded-full
                   blur-3xl animate-float-orb-2"
        style={{ background: 'radial-gradient(circle, rgba(58,98,255,0.40), transparent 60%)' }}
      />

      {/* Türkis Orb unten links */}
      <div
        className="absolute bottom-0 left-1/4 w-[500px] h-[500px] rounded-full
                   blur-3xl animate-float-orb-3"
        style={{ background: 'radial-gradient(circle, rgba(48,210,105,0.25), transparent 60%)' }}
      />

      {/* Grain für Tiefe */}
      <div
        className="absolute inset-0 opacity-[0.025] mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence baseFrequency='0.9' numOctaves='3'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")",
        }}
      />
    </div>
  )
}
